import React, { useEffect, useState, useRef } from 'react';
import { injectIntl, FormattedMessage } from 'react-intl';
import { i18nIntl } from '../../lib/ep';
import { useCSS } from '../../lib/hooks';

import ActionLink from '../builder/ActionLink';
import { InformationMessage } from '../builder/Message';
import Spinner from '../builder/Spinner';
import Tooltip from '../builder/Tooltip';

const SidedCircles = (props) => {
	const width = 300;
	const height = 600;

	const reversed = props?.reversed ?? false;

	let classes = ['sided_circles'];
	if(reversed) classes.push('reversed');

	const x1 = Math.max(140, (152.5 + Math.round(80 * Math.random() - 40)));
	const x2 = Math.max(60, (67.5 + Math.round(80 * Math.random() - 40)));

	const y1 = Math.max(70, (80 + Math.round(100 * Math.random() - 50)));
	const y2 = Math.max(125, (135 + Math.round(100 * Math.random() - 50)));

	return (
		<div class={classes.join(" ")}>
			<svg viewBox={`0 0 ${width} ${height}`}>
				<g style={{transform:`translate(-20px, ${height / 2}px)`}}>
					<g style={{transform:`rotate(${360 * Math.random() - 180}deg)`}}>
						<circle class="st0" cx="0" cy="0" r="112.5"/>

						<g class="animated color_circles">
							<circle class="st0" cx={x1} cy={-y1} r="20"/>

							<circle class="st0" cx={-x1} cy={y1} r="20"/>
						</g>

						<g class="animated white_circles">
							<circle class="st1" cx={x2} cy={-y2} r="15"/>

							<circle class="st1" cx={-x2} cy={y2} r="15"/>
						</g>
					</g>
				</g>
			</svg>
		</div>
	)
};

const EPVerifiedIcon = (props) => {
	const width = 300;
	const height = 245;

	return (
		<div class="ep_verified_logo">
			<svg viewBox={`0 0 ${width} ${height}`}>
				<circle class="circle_outter st1" cx="150" cy="113" r="109" />

				<circle class="circle_inner st2" cx="150" cy="113" r="94" />

				<polyline class="tick_bg st3" points="120,214.7 141.2,236.5 180,196.5" />

				<path class="logo st4 st5" d="M203.4,101.7l-15.7-50.1c-0.3-1-0.7-2-1.4-2.9c-3.4-4.9-10.2-6.1-15-2.7l-70.7,50.2c-4.9,3.5-6.1,10.3-2.6,15.2c2.1,3,5.4,4.6,8.8,4.6h86.4c6,0,10.8-4.9,10.8-10.9C204,103.9,203.8,102.8,203.4,101.7z M168.4,69.1l-43.2,30.5c-0.5,0.3-1,0.5-1.5,0.5c-0.9,0-1.7-0.4-2.2-1.2c-0.9-1.2-0.6-2.9,0.7-3.8l43.2-30.5c1.2-0.9,2.9-0.6,3.8,0.7C169.9,66.6,169.6,68.3,168.4,69.1z" />

				<rect class="st5" x="31" y="131" width="238" height="56" />

				<path class="st0" d="M265,135v48H35v-48H265 M273,127h-8H35h-8v8v48v8h8h230h8v-8v-48V127L273,127z" />

				<path class="st5 st6" d="M60,150H0l25,25L0,200h60V150z" />

				<path class="st5 st6" d="M240,200h60l-25-25l25-25h-60V200z" />

				<polygon class="st7" points="60,200 60,183 35,183" />

				<polygon class="st7" points="240,200 240,183 265,183" />

				<g class="verified">
					<path class="st0" d="M62.9,173L50,145h7.9l8.1,18.6L74,145h7.6l-12.9,28H62.9z" />

					<path class="st0" d="M85.2,173v-28h19.9v5.6H92.3v5.3h12v5.6h-12v5.8h12.9v5.6H85.2z" />

					<path class="st0" d="M111.8,173v-28h13.6c3.2,0,5.7,0.8,7.4,2.3c1.7,1.5,2.6,3.7,2.6,6.5c0,2.1-0.5,3.8-1.6,5.3c-1.1,1.4-2.6,2.4-4.6,3c1.5,0.4,2.7,1.4,3.6,3.1l4.4,7.9h-8.1l-4.9-8.9c-0.3-0.6-0.7-1-1.2-1.2c-0.5-0.2-1.1-0.4-1.7-0.4h-2.2V173H111.8z M119.2,157.4h4.9c2.9,0,4.4-1.1,4.4-3.4c0-2.3-1.5-3.4-4.4-3.4h-4.9V157.4z" />

					<path class="st0" d="M142.1,173v-28h7.4v28H142.1z" />

					<path class="st0" d="M156.6,173v-28h19.7v5.6H164v5.6h11.5v5.6H164V173H156.6z" />

					<path class="st0" d="M181.8,173v-28h7.4v28H181.8z" />

					<path class="st0" d="M196.3,173v-28h19.9v5.6h-12.9v5.3h12v5.6h-12v5.8h12.9v5.6H196.3z" />

					<path class="st0" d="M222.9,173v-28h11.7c4.9,0,8.7,1.2,11.4,3.7c2.7,2.4,4,5.9,4,10.3c0,4.4-1.3,7.9-4,10.3c-2.7,2.4-6.5,3.7-11.4,3.7H222.9z M230.3,167.1h3.8c2.8,0,4.9-0.7,6.2-2c1.3-1.3,2-3.4,2-6.1c0-2.7-0.7-4.8-2-6.1c-1.4-1.3-3.4-2-6.2-2h-3.8V167.1z" />
				</g>

				<polyline class="tick_bg st8" points="120,214.7 141.2,236.5 180,196.5" />
			</svg>
		</div>
	)
};

const WinnerWrapper = ({ link, ...props }) => {
	if(link != undefined && link != '') {
		return (
			<ActionLink _href={link}>
				{props.children}
			</ActionLink>
		)
	}

	return props.children;
};

const ReplacementsSummary = ({ replacements, ...props }) => {
	if(replacements == undefined || replacements.length == 0) return null;
	
	let tooltip = '';
	replacements.map((replacement) => {
		tooltip += `<span class="block">${replacement.info}</span>`;
	});

	return (
		<Tooltip
			icon='knk-information redIcon'
			_class="with_replacements"
		>{tooltip}</Tooltip>
	)
};

const PaintWinnersList = ({ winners, ...props }) => {
	const prize = props?.prize ?? false;
	if(prize === false ) return null;

	const linked = props?.linked ?? false;
	const is_alternates = props?.is_alternates ?? false;
	const info_replacement = props?.info_replacement ?? true;
	
	let ul_classes = ['winners_list'];
	if(!linked) ul_classes.push('not_linkable');

	return (
		<ul class={ul_classes.join(" ")}>
			{winners.map((winner, w) => {
				const winner_name = winner;
				let winner_counter = w + 1;
				if(winners.length > 10 && winner_counter < 10) winner_counter = `0${winner_counter}`;

				return (
					<li key={`${(!is_alternates) ? 'winner' : 'alternate'}_${w}`}>
						<span class="prize_number">{winner_counter}. </span>

						<span class="user">
							<WinnerWrapper>
								<div style={{height:'1.3em'}}>
									<span class="winner_username gui_cutTextOnOverflow">{winner_name}</span>
								</div>

								{(info_replacement) && (
									<ReplacementsSummary replacements={winner.replacements} />
								)}
							</WinnerWrapper>

							{(prize.title != undefined && !is_alternates) && (
								<span class="gui_ribbons">
									<span class="ribbon in_top gui_not_in_bottom_tiny">{prize.title}</span>
								</span>
							)}
						</span>
					</li>
				)
			})}
		</ul>
	)
};

const PrizeCertificate = (props) => {
	useCSS('comp/certificate.css');

	const i18n = (m, c) => i18nIntl(m, props.intl, c);

	const [ winners, setWinners ] = useState([]);
	const [ alternates, setAlternates ] = useState([]);
	const [ replacements, setReplacements ] = useState([]);
	const [ loaded, setLoaded ] = useState(false);
	const [ display_winners, setDisplayWinners ] = useState(!(props?.winners_disabled ?? false));

	const prize = props?.prize ?? {};

	const winners_list_id = 'winners_list';
	const alternates_list_id = 'alternates_list';

	const winners_html = useRef(false);
	const alternates_html = useRef(false);

	const origins = props?.origins ?? [];

	const is_spanish = props?.is_spanish ?? false;
	const link_to_toc = `${window.web_base_url}${is_spanish ? 'condiciones-de-uso/' : 'terms-and-conditions/'}`;

	useEffect(() => {
		if(!display_winners)return;
		$.get(`/v24/certificate/${prize.promotion_id}/${prize.id}`, (res) => {
			setLoaded(true);
			if(res.status == 1){
				if(res?.data?.winners != undefined)setWinners(res.data.winners);
				if(res?.data?.alternates != undefined)setAlternates(res.data.alternates);
				if(res?.data?.replacements != undefined)setReplacements(res.data.replacements);
			}

			if(window.server_type != '2') {

				let _winner_list_id = document.getElementById(winners_list_id) != undefined ? document.getElementById(winners_list_id) : false
				let _alternates_list_id = document.getElementById(alternates_list_id) != undefined ? document.getElementById(alternates_list_id) : false
	
				winners_html.current = _winner_list_id ? _winner_list_id.innerHTML : null;
				alternates_html.current = _alternates_list_id ? _alternates_list_id.innerHTML : null;
	
				// apply a time interval every 0.5 sec to verify the winner list has not been changed through Element Inspector
				setInterval(() => {
					let is_troll = false;
					if(_winner_list_id && _winner_list_id.innerHTML != winners_html.current) {
						_winner_list_id.innerHTML = winners_html.current;
						is_troll = true;
					}
	
					if(_alternates_list_id && _alternates_list_id.innerHTML != alternates_html.current) {
						_alternates_list_id.innerHTML = alternates_html.current;
						is_troll = true;
					}
	
					if(is_troll) {
						setTimeout(() => {
							alert("«Can't touch this»,\nM.C. Hammer");
						}, 150);
					}
				}, 500);
			}
		}, 'JSON').error((xhr, ajaxOptions, thrownError) => {
			setDisplayWinners(false);
		});
	}, []);

	const has_lots_of_winners = ((winners.length + alternates.length) > 16) ? true : false;

	const reasons = {
		1:"voluntary rejection",
		2:"claiming period expired",
		3:false,	// custom message from admin
		4:"alternate replacement",
	};

	return (
		<section class="new_winners_certificate">
			<header class="c_header">
				<SidedCircles />

				<SidedCircles reversed={true} />

				<div class="header_contents">
					<EPVerifiedIcon />

					<h1>{i18n("Easypromos Verified Certificate")}</h1>

					<FormattedMessage
						id="This giveaway has been done randomly according to the requirements of the mechanism described in section {section} of {link}."
						values={{section:'13', link:<ActionLink _href={link_to_toc} _target="_blank">Easypromos terms and conditions</ActionLink>}}
					/>
				</div>
			</header>

			<main class="c_body">
				<dl class="c_info">

					<div class="main_info">
						<dt>{i18n("Title")}</dt>

						<dd dangerouslySetInnerHTML={{ __html:props.certificate_title}} />
					</div>

					<div>
						<dt>{i18n("giveaway", 'ucfirst')}</dt>

						<dd dangerouslySetInnerHTML={{ __html:props.certificate_name}} />
					</div>
					{(props.certificate_type) && (
						<div>
							<dt>{i18n("Type")}</dt>

							<dd dangerouslySetInnerHTML={{ __html:props.certificate_type}} />
						</div>
					)}

					<div>
						<dt>{i18n("Giveaway ID")}</dt>
						<dd dangerouslySetInnerHTML={{ __html:props.certificate_ref}} />
					</div>

					{(origins.length > 0) && (
						<div>
							<dt>{i18n("Publications")}</dt>

							<dd class="list_origins_in_certificate gui_margined_children_v">
								{origins.map((net, n) => {
									return (
										<React.Fragment key={`net_${n}`}>
											{net.map((social_page, s) => {
												return (
													<div key={`page_${s}`}>
														<ActionLink
															_href={social_page.page_link}
															_target="_blank"
															autotranslate={false}
															icon={`ep-${net}`}
														>{social_page.page_name}</ActionLink>

														<ul class="gui_link_actions">
															{social_page.post_link.map((post, p) => {
																const cont = p + 1;
																const winner_index = (social_page.post_link.length > 10 && cont < 10) ? `0${cont}` : cont;

																let item_label = i18n("Post");
																return (
																	<li key={`action_${p}`}>
																		<ActionLink
																			_href={post}
																			_target="_blank"
																		>{`${item_label} #${winner_index}`}</ActionLink>
																	</li>
																)
															})}
														</ul>
													</div>
												)
											})}
										</React.Fragment>
									)
								})}
							</dd>
						</div>
					)}

					{(props.certificate_organizer) && (
						<div>
							<dt>{i18n("Organizer")}</dt>

							<dd>{props.certificate_organizer}</dd>
						</div>
					)}

					{((props?.total_participants ?? 0) > 0) ? (
						<div>
							<dt>{i18n("Number of finalists")}</dt>
							<dd>{props.total_participants}</dd>
						</div>
					) : (<div></div>)}

					<div>
						<dt>{i18n("Date and time of giveaway")}</dt>

						<dd>{props.certificate_date} CEST</dd>
					</div>

				  

					{(loaded && display_winners && winners.length > 0) && (
						<div class={`c_winners${(has_lots_of_winners) ? ' long_list' : ''}`}>
							<dt class="ep-winners">{i18n("Winners")}</dt>

							<dd id={winners_list_id}>
								<PaintWinnersList
									prize={prize}
									winners={winners}
									info_replacement={false}
								/>
							</dd>
						</div>
					)}

					{(loaded && display_winners && alternates.length > 0) && (
						<div class={`c_alternates${(has_lots_of_winners) ? ' long_list' : ''}`}>
							<dt class="ep-winners grayIcon">{i18n("Alternates")}</dt>

							<dd id={alternates_list_id}>
								<PaintWinnersList
									prize={prize}
									winners={alternates}
									first_count={1}
									is_alternates={true}
								/>
							</dd>
						</div>
					)}
				</dl>

				{(loaded && display_winners && replacements.length > 0) && (
					<ul class="replacements_log">
						<li class="title knk-replace-user hb_mainFontWeightBold">{i18n("Replacement logs")}</li>

						{replacements.map((item, i) => {
							const has_won = (item.type == 4) ? true : false;
							const user_name = item.user;
							let reason = reasons[item.type]
							let label = "{date} - {user} lost the prize: {reason}";
							if(has_won){
								label = "{date} - {user} won the prize: {reason}";
							}
							if(item.type == 3)reason = item.msg;
							return (
								<li key={`log_${i}`}>
									<FormattedMessage id={label} values={{date:item.date,user:<strong>{user_name}</strong>,reason:reason}} />
								</li>
							)

							
							/*return (
								<li key={`log_${i}`}>
									{`${i18n("Winner")} ${l.prize_position} `}
									<FormattedMessage id="{date}: {source} replaces {target}. {msg}" values={{date:`- [${l.date}]`,source:<strong>{l.source}</strong>,target:<strong>{l.target}</strong>,msg:l?.msg ?? i18n("No prize claimed")}} />
								</li>
							)*/
						})}
					</ul>
				)}

				{(!display_winners) && (
					<InformationMessage
						_class={{ other:'in_bottom' }}
					>
						<p>{i18n("The name of the winners and the alternates are not public. For any question, contact with the sweepstakes organizer.")}</p>
					</InformationMessage>
				)}

				{(display_winners && !loaded) && (
					<div class="gui_pos_rel not_in_top" style={{ minHeight:'100px' }}>
						<Spinner>Loading certificate results</Spinner>
					</div>
				)}
			</main>

			<footer class="c_footer">
				<p>{i18n("Easypromos will not be responsible for any complaint of third parties regarding prizes, winners and/or alternate winners")}</p>
			</footer>
		</section>
	)
};

export default injectIntl(PrizeCertificate);